var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGroupsInactive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22 22a8 8 0 0 0-16 0h2a6 6 0 1 1 12 0zm-8-9c3.315 0 6-2.685 6-6s-2.685-6-6-6-6 2.685-6 6 2.685 6 6 6m0-2c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4m-8.284 3.703A8 8 0 0 0 1 22h2a6 6 0 0 1 3.537-5.473zm.688-11.29a5.5 5.5 0 0 0-1.967 8.796A5.5 5.5 0 0 0 8 13.978v-2.013a3.5 3.5 0 0 1-1.041-6.609z"
})));
export default SvgGroupsInactive;